/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Caption_Lock_TitleInputs */



/**
* | output |
* | --- |
* | "Lock CC or AD to Video" |
*
* @param {Player_Caption_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_caption_lock_title = /** @type {((inputs?: Player_Caption_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Caption_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouiller CC ou AD sur la Video")
	if (locale === "de") return /** @type {LocalizedString} */ ("CC oder AD an Video sperren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocca CC o AD sul video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Привязать субтитры или рекламу к видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloquear CC o AD en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁定 CC 或 AD 到视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CC または AD をビデオにロックする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो पर CC या AD को लॉक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bloquear legendas ou anúncios no vídeo")
	return /** @type {LocalizedString} */ ("Lock CC or AD to Video")
});